import { TimePickerProps, TimePicker } from './TimePicker'
import { useField } from 'formik'
import { FormControl, InputGroup, FormControlProps } from '@chakra-ui/react'
import React from 'react'

export type TimePickerInputProps = {
  name: string
} & Omit<TimePickerProps, 'value'> &
  FormControlProps

export function TimePickerInput({ name, ...props }: TimePickerInputProps) {
  const [field, meta, helpers] = useField(name)

  return (
    <FormControl isInvalid={!!meta.error && meta.touched} {...props}>
      <InputGroup>
        <TimePicker {...props} onChange={(newValue) => helpers.setValue(newValue)} value={field.value} />
      </InputGroup>
    </FormControl>
  )
}
